import React, { useState, useEffect, Suspense } from "react";
//import { Link, animateScroll as scroll } from "react-scroll";
import "./App.css";
import Navbar from "../Navbar/Navbar";
import Contact from "../Contact/Contact";
import SideBar from "../Navbar/SideBar";
import Projects from "../../pages/projects/Projects/Projects";
import Intro from "../Intro/Intro";
import Skills from "../Skills/Skills";
import Recommendation from "../../pages/Recommendation/Recommendation";
import { Route, Routes } from "react-router-dom";
import ErrorPage from "./../../pages/ErrorPage.tsx";
import OpenSource from "../../pages/OpenSourse";
import ProjectDetail from "../../pages/projects/ProjectDetail";
import BottomNavigation from "../Overley/BottomNavigation";
import RootLayout from "../../layout/RootLayout";
import { IconContext } from "react-icons";
import Home from "../Home/Home.jsx";

const App = () => {
  return (
    <div className="h-screen">
      <IconContext.Provider
        value={{ size: "24px", color: "rgb(33, 150, 243)" }}
      >
        <Routes>
          <Route path={`/`} element={<RootLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<Intro />} />
            <Route path="skills" element={<Skills />} />
            <Route path="projects">
              <Route index element={<Projects />} />
              <Route path=":project" element={<ProjectDetail />} />
            </Route>
            <Route path="recommendation" element={<Recommendation />} />
            <Route path="contact" element={<Contact />} />
            <Route path="open-source-contribution" element={<OpenSource />} />
            <Route path="*" element={<ErrorPage />} />
          </Route>
          <Route path="*" element={<ErrorPage />}></Route>
        </Routes>
      </IconContext.Provider>
    </div>
  );
};

export default App;
